import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DxSortableModule, DxTabPanelModule, DxTemplateModule } from 'devextreme-angular';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { HeaderComponent } from './header/header.component';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';
import { ScrolltopComponent } from './scrolltop/scrolltop.component';
import { RouterModule } from '@angular/router';
// import { ChatBotComponent } from './widget/chat-bot/chat-bot.component';
// import { NgxMicrosoftBotFrameworkModule } from 'ngx-microsoft-bot-framework';
import { NgxSpinnerModule } from "ngx-spinner";
import { FilterGeneralPipe } from '../../shared/pipes/filter/filter-general.pipe';
import { NotificationsComponent } from './notifications/notifications.component';
import { SettingsComponent } from './settings/settings.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { moreaccessComponent } from './moreaccess/moreaccess.component';
import { recentComponent } from './recent/recent.component';
import { boardcomponent } from './board/board.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DxSelectBoxModule, DxTextBoxModule,DxTreeListModule,DxTreeViewComponent,DxContextMenuModule , DxTreeViewModule } from 'devextreme-angular';
import { PipesModule } from "../pipes/pipesModule";

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    HeaderComponent,
    NopagefoundComponent,
    SidebarComponent,
    HeaderMobileComponent,
    ScrolltopComponent,
    FilterGeneralPipe,  
    NotificationsComponent,
    SettingsComponent,
    FavoritesComponent ,
    moreaccessComponent,
    recentComponent,
    boardcomponent
  ],
  exports:[
    BreadcrumbsComponent,
    HeaderComponent,
    NopagefoundComponent,
    SidebarComponent,
    HeaderMobileComponent,
    ScrolltopComponent,

  ],
  imports: [
    CommonModule,
    RouterModule,

    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    DxSortableModule, 
    DxSelectBoxModule,
    DxTabPanelModule,
    DxTemplateModule,
    DxTreeListModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxContextMenuModule,
    PipesModule,
    TooltipModule.forRoot()
  ]
})
export class LayoutModule { }
